import { call, put, takeLatest } from 'redux-saga/effects'
import { types, IGetGroupsDetailedAction } from '../types/groupsDetailed'
import * as actions from '../actions/groupsDetailed'
import * as services from '../services/groups'
import { trace } from '../services/common'

export function* getGroupsDetailedSaga(action: IGetGroupsDetailedAction) {
  try {
    const list = yield call(services.getGroupsDetailed)
    yield put(actions.getGroupsDetailedSuccess(list))
  } catch (err) {
    trace(err)
    yield put(actions.getGroupsDetailedFailure(err.message))
  }
}

export function* groupsDetailedWatcher() {
  yield takeLatest(types.GET_GROUPS_DETAILED__STARTED, getGroupsDetailedSaga)
}
